import React, { ReactElement } from 'react';
import { TerminDetail } from 'tezaury-frontend-ts-axios';
import { Col, Row } from 'idsk-react-components';
import { useNavigate, useParams } from 'react-router';
import DetailTerminuSectionHeading
  from '../DetailTerminuSectionHeading/DetailTerminuSectionHeading';
import DetailTerminuRow from '../DetailTerminuRow/DetailTerminuRow';
import DetailTerminuList from '../DetailTerminuList/DetailTerminuList';
import mapDate from '../../../functions/mapDate';
import parseDate from '../../../functions/parseDate';
import routes from '../../../routing/routes';

interface Props {
  termin: TerminDetail;
  admin?: boolean;
}

const DetailTerminuZakladneUdaje = ({ termin, admin = false }: Props) : ReactElement => {
  const navigate = useNavigate();
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  return (
    <>
      {admin && (
        <DetailTerminuSectionHeading
          heading="Základné údaje"
          admin={admin}
          marginTop={false}
          onClick={() => navigate(routes.tezaurus.admin.termin.edit.termin.withParams(tezaurusUuid, terminUuid))}
          terminListNotEmpty={termin.preferovanyTermin.length > 0}
        />
      )}

      <Row>
        <Col width="one-half">
          <DetailTerminuRow header="Preferovaný termín" division="halves">
            {termin.preferovanyTermin}
          </DetailTerminuRow>
          {admin || termin.alternativnyTerminList.length > 0 ? (
            <DetailTerminuRow header="Alternatívne termíny" division="halves">
              <>
                {/* eslint-disable-next-line no-nested-ternary */}
                {termin.alternativnyTerminList.length > 0 ? (
                  <DetailTerminuList
                    list={termin.alternativnyTerminList}
                    propertyName="alternativnyTermin"
                    renderKey={(item) => item.uuid}
                  />
                ) : (
                  admin ? <span>-</span> : null
                )}
              </>
            </DetailTerminuRow>
          ) : null}
          {!admin && (
            <>
              <DetailTerminuRow header="Tezaurus" division="halves">
                {termin.tezaurus.nazov}
              </DetailTerminuRow>
              <DetailTerminuRow header="Dátum poslednej zmeny" division="halves">
                {termin.datumPoslednejZmeny ? mapDate(parseDate(termin.datumPoslednejZmeny), 'dd.mm.yyyy') : undefined}
              </DetailTerminuRow>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};

export default DetailTerminuZakladneUdaje;
